__turbopack_context__.v({
  "policy_details_styles": "J7Cu2W_policy_details_styles",
});
